module.exports = __webpack_public_path__ + "img/other.024556bc.png";